<template>
    <span>
        <span v-if="internalValue" :titlex="formatDate(internalValue)">{{ formattedDate }}</span>
        <span v-if="!internalValue">-</span>
    </span>
</template>

<script>
    import moment from "moment";

    export default {
        name: 'Date',
        props: ['value','label','name','placeholder','human','useLocalTz'],
        data: function () {
            return {
                internalValue: '',
                localTz: false
            }
        },
        created: function() {
            this.formattedDate = this.formatDateHuman(this.value);
            this.internalValue = this.value;
            this.localTz = this.useLocalTz ? true : false;
        },
        methods: {
          formatDateHuman: function(value){

                if( value == null ){
                  return "Non défini";
                }

                if( this.human )
                {
                  let date = moment(value);
                  if( date.isBefore(moment()) ){
                    return this.$helpers.utcToLocal(value, this.$store.state.scope.timezone).fromNow()
                  }else{
                    return this.$helpers.utcToLocal(value, this.$store.state.scope.timezone).fromNow()
                  }

                }else{
                    return this.formatDate(value)
                }
            },
            formatDate: function(value){

              return this.$helpers.utcToLocal(value, this.$store.state.scope.timezone).format('DD.MM.YYYY HH:mm:ss')

            }
        },
        watch: {
            'value'(newVal, oldVal) {
              this.internalValue = newVal
              this.formattedDate = this.formatDateHuman(newVal);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Datetime.vue